import React from "react";
import { BaseBox, BaseTypography } from "../exports";
import logo from '../../../assets/vodafone-logo.png'; // logo path
import { Button, FormControl, Select, MenuItem } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { getTokenIssuer, getTenants } from "../../../Utils/JWTTokenUtil";
import { clearAppCache } from "../../../Utils/appCache";
import { useNavigate } from "react-router-dom";

export default function BaseHeader({ }) {
  const email = localStorage.getItem("email");

  const { instance } = useMsal();
  const navigate = useNavigate();
  const issuer = getTokenIssuer();
  const tenants = getTenants();
  const [selectedOption, setSelectedOption] = React.useState(() => {
    return localStorage.getItem("selectedTenant") || tenants[0] || "";
  });

  const handleDropdownChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    localStorage.setItem("selectedTenant", value);
    window.location.reload();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("selectedTenant");
    clearAppCache();

    if (issuer !== "ITaaP") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/"
      });
    }
    navigate("/", { replace: true });
  };

  return (
    <BaseBox
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        bgcolor: "#f9f9f9",
        color: "#333",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 1000,
        px: 2,
        py: 1,
      }}
    >
      <BaseBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Left: Logo + Dropdown */}
        <BaseBox sx={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="Vodafone Logo" style={{ width: 35 }} />

          <BaseBox sx={{ ml: 2 }}>
            <FormControl size="small" sx={{ width: "35%" }}>
              <Select value={selectedOption} onChange={handleDropdownChange}>
                {tenants.map((tenant) => (
                  <MenuItem key={tenant} value={tenant}>{tenant.toUpperCase()}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </BaseBox>
        </BaseBox>

        {/* Spacer to push email to the right */}
        <BaseBox sx={{ flexGrow: 1 }} />

        {/* Right: User email */}
        <BaseBox sx={{ maxWidth: "50%", overflow: "hidden" }}>
          <BaseTypography
            sx={{
              fontSize: "1em",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              textAlign: "right",
            }}
          >
            {email}
          </BaseTypography>
        </BaseBox>
        <Button onClick={handleLogout}>
          SignOut
        </Button>
      </BaseBox>
    </BaseBox>
  );
}
